<script>
import { mapState } from 'vuex'
import {authEasyMethods} from "@/state/helpers"
import { required, email } from "vuelidate/lib/validators"
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false
    }
  },
  validations: {
    email: { required, email }
  },
  computed: {
    ...mapState({ 
      notification: state => state.notification 
    })
  },
  created() {
    document.body.classList.add("auth-body-bg")
  },
  methods: {
    ...authEasyMethods,    
    enter: (el, done) => {
      done();
    },
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      } else {
        this.tryingToReset = true
        // Reset the authError if it existed.
        this.error = null
        return this.resetpassWord({ email: this.email })
            .then((response) => {
              this.isResetError = false
              Swal.fire({
                title: 'Redefinição de senha',
                text: (response && response.message) || 'Link para redefinição de senha enviado para o e-mail.',
                icon: 'success',
                confirmButtonText: 'Ok'
              })
              this.email = ''
              this.$v.$reset()
              return response
            })
            .catch((error) => {
              this.tryingToReset = false
              this.error = (error && error.message) || error
              this.isResetError = true
              Swal.fire({
                title: 'Erro',
                text: (error && error.message) || 'Ocorreu um erro ao tentar redefinir a senha. Verifique o e-mail digitado.',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
              return Promise.reject(error)
            })
            .finally(() => {
              this.tryingToReset = false
              this.submitted = false
            })
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo.png" height="90" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Redefinir senha</h4>
                        <p class="text-muted">redefina sua senha para o EasySaude.</p>
                      </div>

                      <div class="p-2 mt-5">
                        <!-- Notificação -->
                        <b-alert
                          v-model="isResetError"
                          class="mb-4"
                          variant="danger"
                          dismissible
                          :show="!!notification.message"
                        >{{notification.message}}</b-alert>

                        <form class="form-horizontal" @submit.prevent="tryToReset">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">E-mail</label>
                            <input
                              v-model="email"
                              type="email"
                              class="form-control"
                              id="useremail"
                              placeholder="Digite seu e-mail"
                              :class="{ 'is-invalid': submitted && $v.email.$error }"
                            />
                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                              <span v-if="!$v.email.required">E-mail obrigatório.</span>
                              <span v-if="!$v.email.email">Por favor, digite o e-mail.</span>
                            </div>
                          </div>

                          <transition name="fade" v-on:enter="enter">
                            <div class="mt-4 text-center">
                              <i v-if="submitted" class="fa fa-spinner fa-5x fa-spin text-success"></i>
                            </div>
                          </transition>
                          <div class="mt-4 text-center">
                            <button v-if="!submitted"
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >Alterar</button>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          © 2024 EasySaude 1.0. <a href="https://sidsolucoes.com">SiD Soluções</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>